import { jsx as o } from "react/jsx-runtime";
import { Children as i, cloneElement as s } from "react";
import '../../assets/EqualSizeFlexRow.css';const f = {
  "equal-size-flex-row__item": "_equal-size-flex-row__item_qnkaz_11"
}, u = (r, e, t) => `${t.length <= e ? 1 : 0} 1 calc(${t.length <= e ? 100 / t.length : 100 / e}% - ${r})`;
function h({ children: r, gap: e = "1.5rem", maxItemsPerRow: t = 4 }) {
  const l = i.toArray(r), a = l.length === 1 ? "0 1 50%" : u(e, t, l);
  return /* @__PURE__ */ o(
    "equal-size-flex-row",
    {
      style: {
        "--esfr-gap-size": e,
        "--esfr-item-flex": a,
        "--esfr-flex-wrap": l.length > t ? "wrap" : "nowrap"
      },
      "data-item-count": l.length,
      children: l.map((n) => /* @__PURE__ */ o(
        "div",
        {
          className: f["equal-size-flex-row__item"],
          children: s(n, n.props)
        },
        `esfr-${Math.round(Math.random() * 1e7)}`
      ))
    }
  );
}
export {
  h as EqualSizeFlexRow,
  h as default
};
